import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { appendURlWithParam, isAccessTokenStale, isMobile, isPartnerAffiliated, setAppHeader, showEarning } from '../../configs/utils';
import { ACTION } from "../partnerWeb_Dashboard/types";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { SideBarBuilderDS } from "../sideNavBar";
import { onChangeTab, onDownLoadEarningReport, openMenu, promoBannerInvite } from "./action";
import { BottomNavBuilderDS } from "../bottomNav";
import { GoToFaq, GoToHome, GoToPhone } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress } from "../partnerWeb_Dashboard/actions";
import { EarningTableDataBuilder, ShowNewRmContactButton } from "../partnerWeb_Dashboard/utils";
import { EmptyEarningMobEmptyStateStack } from "./EarningEmptyState";
import { partnerApi, StoreKey } from "../../configs/api";
import { onShareLinkWithRef } from "../leads/actions";
import sharedPropsService from "../../SharedPropsService";
import { initializeFirebase } from "../../configs/config";
import { getAppHeader } from '../../configs/config';
const _isMobile = isMobile();
export const template = async (partnerAccountType, partnerAccountID, earningReportMonth, showNewRmContactButton, rmData, isFromMobile) => ({
    layout: {
        id: ROUTE.EARNING,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            !isMobile()
                ? {
                    id: 'sideNav',
                    type: WIDGET.STACK,
                    position: POSITION.NAVBAR_LEFT,
                }
                : {},
            { id: 'EarningPageMainStack', type: WIDGET.STACK },
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ]
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.EARNING,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...await PartnerHeader(ROUTE.EARNING),
        ...await SideBarBuilderDS(ROUTE.EARNING),
        ...await BottomNavBuilderDS(ROUTE.EARNING),
        EarningPageMainStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: [
                { id: 'EarningPageTitle', type: WIDGET.TEXT },
                { id: 'EarningPageSubtitle', type: WIDGET.TEXT },
                { id: 'space24', type: WIDGET.SPACE },
                { id: 'EarningPageDivider', type: WIDGET.DIVIDER },
                showEarning(partnerAccountType) ? { id: 'EarningPageSpace0', type: WIDGET.SPACE } : {},
                showEarning(partnerAccountType) && !isPartnerAffiliated(partnerAccountType) ? { id: "downloadSpace", type: WIDGET.SPACE } : {},
                showEarning(partnerAccountType) && !isPartnerAffiliated(partnerAccountType) ? { id: "downloadStack", type: WIDGET.STACK } : {},
                !_isMobile && showEarning(partnerAccountType) && isPartnerAffiliated(partnerAccountType) ? { id: 'EarningTableStack', type: WIDGET.STACK } : {},
                _isMobile && showEarning(partnerAccountType) && isPartnerAffiliated(partnerAccountType) ? { id: 'EmptyEarningMobEmptyStateStack', type: WIDGET.STACK } : {}
            ]
        },
        ...await EmptyEarningMobEmptyStateStack(partnerAccountType),
        EarningTableStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                !_isMobile ? { id: 'EarningTable', type: WIDGET.TABLE } : {},
            ],
        },
        EarningTable: {
            numOfCol: 8,
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            titleMap: {
                ...EarningTableDataBuilder([])
                    .Title_MAP,
            },
            titleConfig: {
                ...EarningTableDataBuilder([])
                    .TITLE_CONFIG,
            },
            data: [],
        },
        EarningPageDivider: {
            size: DividerSizeTokens.MD,
            color: ColorTokens.Grey_Chalk,
        },
        EarningPageTitle: {
            label: 'Earnings',
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: _isMobile ? FontSizeTokens.MD : FontSizeTokens.LG,
            lineHeight: _isMobile ? 24 : 26,
        },
        EarningPageSubtitle: {
            label: showEarning(partnerAccountType) ? 'Track your earning easily' : 'Track your earnings',
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            lineHeight: _isMobile ? 24 : 26,
            color: ColorTokens.Grey_Charcoal
        },
        EarningPageSpace0: {
            size: _isMobile ? SizeTypeTokens.MD : SizeTypeTokens.XXXL
        },
        space24: {
            size: SizeTypeTokens.XXXL
        },
        downloadSpace: {
            size: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXL
        },
        downloadStack: {
            type: _isMobile ? StackType.column : StackType.row,
            width: StackWidth.MATCH_PARENT,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "downloadEarningsTitle", type: WIDGET.TEXT },
                { id: "space16", type: WIDGET.SPACE },
                { id: "downLoadButton", type: WIDGET.BUTTON }
            ]
        },
        downloadEarningsTitle: {
            label: `Download the earnings report for the month of ${earningReportMonth}`,
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 24,
            fontFamily: FontFamilyTokens.Inter,
            color: ColorTokens.Grey_Charcoal
        },
        downLoadButton: {
            width: _isMobile ? ButtonWidthTypeToken.FULL : ButtonWidthTypeToken.CONTENT,
            label: 'Download',
            fontSize: FontSizeTokens.SM,
            action: {
                type: ACTION.DOWNLOAD_EARNING_REPORT,
                routeId: ROUTE.EARNING,
                payload: {
                    value: partnerAccountID
                }
            },
            loading: false
        },
        space16: {
            size: _isMobile ? SizeTypeTokens.XXXL : SizeTypeTokens.XL
        },
    },
});
export const EarningPageMF = {
    onLoad: async ({ asyncStorage, network, instrumentTrack, ...props }, { action }) => {
        await setAppHeader();
        await initializeFirebase();
        const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        let partnerAccountType = undefined;
        let partnerAccountID;
        const earningReportMonth = await sharedPropsService.getFirebaseConfig()?.earnings_report_month;
        appendURlWithParam('earning');
        if (await isAccessTokenStale({ asyncStorage: asyncStorage,
            network: network })) {
            partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
            partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
        }
        else {
            partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
            partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
        }
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const isFromMobile = isMobile();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountID}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        return Promise.resolve(template(partnerAccountType, partnerAccountID, earningReportMonth, showNewRmContactButton, rmData, isFromMobile));
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: promoBannerInvite,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.SHARE_LINK_REF]: onShareLinkWithRef,
        [ACTION.DOWNLOAD_EARNING_REPORT]: onDownLoadEarningReport,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
    }
};
